module.exports = __webpack_public_path__ + "img/Chile.22f32488.png";